import axios from "axios";
import { Children, FC, ReactNode, useRef } from "react";

const Math: FC<{children: ReactNode}> = ({children}) => {
    const previewRef = useRef<HTMLImageElement>(null)
    axios.post('/math_preview', {tex: children}).then(({data})=>{
        if (previewRef.current){
            previewRef.current.src = 'data:image/svg+xml;base64,' + btoa(data.svg)
            previewRef.current.style.verticalAlign = data.verticalAlign + 'pt'
        }
    });
    return <img alt={String(children)} ref={previewRef}/>
}

export const WithMath: FC<{children: ReactNode}> = ({children}) => {
    const new_children = Children.map(children, child => {
        if ((typeof child === 'string' || child instanceof String) && child.indexOf('<math>') !== -1){
            let parts = child.split(/(<math>.*?<\/math>)/)
            return parts.map((part)=>{
                if (part.indexOf('<math>') === -1){
                    return part
                }
                return <Math>{part.substring(6, part.length - 7)}</Math>
            })
        }
        return child
    })
    return <>{new_children}</>
}

export default WithMath